/*
 *  I15TAUXCOUVBOISReducer.ts
 *
 *  Created by Sébastien Hecart on 2022-06-27 10:29:55 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I15TAUXCOUVBOIS_State } from '@batical/types/src'

const I15TAUXCOUVBOIS: I15TAUXCOUVBOIS_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_puissance_biomasse: 12.0,
  in_puissance_total: 29.0,
  res_couverture_biomasse: 0.0,
  mode: 'none',
  calcul_code: 'I15TAUXCOUVBOIS'
}

export default I15TAUXCOUVBOIS
